
import * as React from 'react';
import { Row as RowStrap } from 'reactstrap';
import * as value from '../../../common';
import * as common from '../common';
import classnames from 'classnames';

export type VerticalAlign = "center" | "start" | "end";
export type HorizontalAlign = "center" | "left" | "right";

export interface IRowProps extends common.ILayoutPropsBase {
    style?: React.CSSProperties;
    className?: string;
    tag?: React.ReactType;
    noGutters?: value.FuncValue<boolean>;
    verticalAlign?: VerticalAlign;
    horizontalAlign?: HorizontalAlign;
    onClick?: () => void;
}

export const Row = (props: IRowProps) => {
    const { verticalAlign, horizontalAlign, className, ...other } = props;
    return <RowStrap
        {...other}
        noGutters={props.noGutters && value.evaluate(props.noGutters)}
        className={classnames(className, verticalAlign ? `align-items-${verticalAlign}` : '', horizontalAlign ? `text-${horizontalAlign}` : '')}
    />;
};